import { render, staticRenderFns } from "./sanjiConfirmPay.vue?vue&type=template&id=129a14aa&scoped=true&"
import script from "./sanjiConfirmPay.vue?vue&type=script&lang=js&"
export * from "./sanjiConfirmPay.vue?vue&type=script&lang=js&"
import style0 from "./sanjiConfirmPay.vue?vue&type=style&index=0&id=129a14aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a14aa",
  null
  
)

export default component.exports